// Tiny Web-Audio based sound helper — generates pleasant tones without
// shipping any audio asset. Two effects exposed:
//   playLogin()       — soft 2-note ascending chime (login success)
//   playDing()        — single bell-like ding (new notification)
// All calls are best-effort and silent if audio is blocked.

let _ctx = null;
const ctx = () => {
  try {
    if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
    return _ctx;
  } catch { return null; }
};

const tone = (freq, startAt, durationMs, gain = 0.18, type = "sine") => {
  const ac = ctx(); if (!ac) return;
  const osc = ac.createOscillator();
  const env = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  // Attack–decay envelope to avoid clicks
  env.gain.setValueAtTime(0.0001, ac.currentTime + startAt);
  env.gain.exponentialRampToValueAtTime(gain, ac.currentTime + startAt + 0.02);
  env.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + startAt + durationMs / 1000);
  osc.connect(env).connect(ac.destination);
  osc.start(ac.currentTime + startAt);
  osc.stop(ac.currentTime + startAt + durationMs / 1000 + 0.05);
};

export const playLogin = () => {
  // Ascending C5 → G5 chime
  tone(523.25, 0.0, 220, 0.16, "sine");      // C5
  tone(659.25, 0.12, 220, 0.16, "sine");     // E5
  tone(783.99, 0.24, 320, 0.18, "sine");     // G5
};

export const playDing = () => {
  // Single A5 bell ding
  tone(880.0, 0.0, 320, 0.18, "triangle");
  tone(1318.5, 0.0, 180, 0.10, "sine"); // soft overtone for richness
};
